import React from "react";
import { Link } from "react-router-dom";

export default function CompanyComponent(props) {
  const { item, img, path } = props;
  return (
    <div className="col-md-2 actively_hiring">
      <div className="text-center">
        <div className="actively_hiring_img">
          {/* <img
            src="img/comapny-logos/acuity.jpg"
            className="img-fluid pic-1"
            alt=""
          /> */}
          {item?.company_logo ? (
            <img
              src={path + encodeURI(item?.company_logo)}
              className="img-fluid pic-1"
              alt={item?.company_name}
            />
          ) : (
            // <img src={img} className="img-fluid pic-1" alt={item?.title} />
            <i className="fa fa-image fa-4x" title={item?.company_name}></i>
          )}
        </div>
        <Link
          to={`/company-detail/${item?.id}/${(
            item?.company_name.toLowerCase()
          ).replaceAll(" ", "-")}`}
          className="genric-btn info circle arrow"
        >
          View Jobs
          <span className="lnr lnr-arrow-right" />
        </Link>
      </div>
    </div>
  );
}
